import { render, staticRenderFns } from "./search-radiologist-page.vue?vue&type=template&id=8e9a2fb8&scoped=true"
import script from "./search-radiologist-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./search-radiologist-page.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./search-radiologist-page.vue?vue&type=style&index=0&id=8e9a2fb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e9a2fb8",
  null
  
)

export default component.exports